import { TabContextReporter } from '../TabContext';
import RichText from '../controls/RichText';
import { useForceUpdate } from '../util';
export default function Paragraph(props) {
  const dataProps = props.data.props;
  const forceUpdate = useForceUpdate();
  return /*#__PURE__*/React.createElement(TabContextReporter, {
    key: 0,
    index: "0",
    title: "Text Editor"
  }, /*#__PURE__*/React.createElement(RichText, {
    value: dataProps.text,
    onChange: v => {
      dataProps.text = v;
      forceUpdate();
      props.onChanged();
      props.triggerStateUpdate();
    }
  }));
}